
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import TitleHeader from "@/components/base/table/header/LeftLineHeader.vue";
import { Action, Getter, State } from "vuex-class";
import config, { FormValid } from "@/config";
import cookie from "js-cookie";
import { getCompany } from "@/api/account";
@Component({
  name: "UnitAuthern",
  components: {
    TitleHeader,
  },
})
export default class UnitAuthern extends Vue {
  @Action("getImage") private getImage: any;
  @Action("account/updateRoleBasic") private updateRoleBasic!: any;
  @Action("account/baiduOcr") private baiduOcr!: any;
  @State("basic") private basic!: string;
  @Getter("role") private role!: string;
  @Action("account/getAuthernData") private getAuthern: any;
  @Action("uploadFileOss") private uploadFileOss: any;
  @Action("upload") private upload: any;
  @Getter("id") private id!: any;
  @Getter("registCompany") private registCompany!: any;
  @Action("account/unitAuthern") private unitAuthern: any;
  @Getter("roleSave") private roleSave!: string;
  loadingFlag: Boolean = false;
  loadingFlag2: Boolean = false;
  loadingFlag3: Boolean = false;
  // 移除前
  beforeUploadImg(file: any, item: any) {
    let isEmpty = file.size > 0;
    const nameArray = file.name.split(".");
    let type = nameArray[nameArray.length - 1];
    const supportType = ["bmp", "png", "jpg"];
    let isVedio = supportType.includes(type);
    let isLt100M = file.size / 1024 / 1024 < 5;
    if (!isEmpty) {
      this.$message.error("不能上传空文件");
      return false;
    } else if (!isVedio) {
      this.$message.error("只能上传bmp,png,jpg类型文件");
      return false;
    } else if (!isLt100M) {
      this.$message.error("只能上传5M以内的图片");
      return false;
    }
    return isEmpty && isVedio && isLt100M;
  }
  is_authern: boolean = false;
  dialogVisible: boolean = false;
  authern_model: any = {};
  authern_rules: any = {
    licencePhoto: [
      {
        required: true,
        message: "请上传营业执照",
        trigger: "change",
      },
    ],
    companyName: [
      {
        required: true,
        message: "请输入公司名称",
        trigger: "change",
      },
    ],
    legalName: [
      {
        required: true,
        message: "请输入法人名称",
        trigger: "change",
      },
    ],
    legalId: [
      {
        required: true,
        message: "请输入法人身份证号",
        trigger: "change",
      },
    ],
    licenseNum: [
      {
        required: true,
        message: "请输入统一社会信用代码",
        trigger: "change",
      },
    ],
    companyAddress: [
      {
        required: true,
        message: "请输入营业执照详细地址",
        trigger: "change",
      },
    ],
    registeredCapital: [
      {
        required: true,
        message: "请输入注册资金",
        trigger: "change",
      },
    ],
    establishDate: [
      {
        required: true,
        message: "请输入成立日期",
        trigger: "change",
      },
    ],
    validPeriod: [
      {
        required: true,
        message: "请输入截至日期",
        trigger: "change",
      },
    ],
    scope: [
      {
        required: true,
        message: "请输入法定经营范围",
        trigger: "change",
      },
    ],
    legalPhoto: [
      {
        required: true,
        message: "请上传身份证正面照片",
        trigger: "input",
      },
    ],
    legalPhotof: [
      {
        required: true,
        message: "请上传身份证反面照片",
        trigger: "change",
      },
    ],
  };
  action: any = `${config.commonUrl}common/upload/fileOcr`;
  headers: any = {};
  authern_list: any = [];
  disabled = false;
  ref_authern_form: string = "ref_authern_form";
  created() {
    this.headers["accessToken"] = cookie.get("accessToken");
    this.roleSave == "1" ? (this.is_authern = true) : (this.is_authern = false);
    if (this.roleSave == "1") {
      this.getData();
    }
  }
  getData() {
    getCompany({}).then((res: any) => {
      this.authern_model = res.data.result;
    });
  }
  handleProgress() {
    this.loadingFlag = true;
  }
  handleProgress2() {
    this.loadingFlag2 = true;
  }
  handleProgress3() {
    this.loadingFlag3 = true;
  }
  beforeUpload(file: any) {
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      this.$message.error("文件大小不能超过 10M!");
    }
    return isLt10M;
  }
  uploadSuccess(response: any) {
    this.$refs[this.ref_authern_form].clearValidate("licencePhoto");
    this.loadingFlag = false;
    const {
      name,
      registerNumber,
      address,
      capital,
      establishDate,
      validPeriod,
      business,
    } = response.result.BusinessLicense.data;
    this.authern_model = {
      ...this.authern_model,
      licencePhoto: response.result.url,
      companyName: name,
      licenseNum: registerNumber,
      companyAddress: address,
      registeredCapital: capital,
      establishDate: establishDate,
      validPeriod: validPeriod,
      scope: business,
    };
  }
  showBig() {
    if (this.is_authern) {
      this.dialogVisible = true;
    }
  }

  uploadSuccess2(response: any) {
    this.$refs[this.ref_authern_form].clearValidate("legalPhoto");
    this.loadingFlag2 = false;
    this.authern_model = {
      ...this.authern_model,
      legalPhoto: response.result.url,
      legalName: response.result.IdentityCard.data.frontResult.name,
      legalId: response.result.IdentityCard.data.frontResult.iDNumber,
    };
  }
  uploadSuccess3(response: any) {
    this.$refs[this.ref_authern_form].clearValidate("legalPhotof");
    this.loadingFlag3 = false;
    this.authern_model = {
      ...this.authern_model,
      memberId: this.id,
      legalPhotof: response.result.url,
    };
  }
  submit() {
    this.$refs[this.ref_authern_form].validate((valid: any) => {
      if (valid) {
        this.unitAuthern(this.authern_model).then((res: any) => {
          console.log(res);
          const { code, result, msg } = res;
          if (code === 200) {
            this.is_authern = true;
            const basic: any = this.basic;
            basic.roleSave = 1;
            basic.token = result.accessToken;
            this.updateRoleBasic(basic);
            this.$message.success("认证成功");
            // 跳转首页
            this.$router.push({ name: "PcmHome" });
          } else {
            return this.$message.warning("认证失败");
          }
        });
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
}
